import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import ScrollToTop from "../components/ScrollToTop";
import logo from '../assets/images/ekc-logo-white.webp';
import { NavItem } from "../common/types";
import { getSiteGlobals } from "../utils/api";
import { useEffect, useState } from "react";
import { useOutlet } from "react-router-dom";

const fallbackNavItems: NavItem[] = [
    { type: "link", label: "Home", to: "/", visible: true },
    { type: "link", label: "Our Approach", to: "/our-approach", visible: true },
    {
        type: "dropdown",
        label: "Clusters",
        clickableLabel: false,
        visible: true,
        leftColumn: {
            title: "Clusters",
            items: [
                { label: "Advanced Manufacturing", to: "/advanced-manufacturing" },
                { label: "Architecture-Engineering", to: "/architecture-engineering" },
                { label: "Cybersecurity", to: "/cybersecurity" },
                { label: "Digital Health", to: "/digital-health" },
                { label: "Financial Services-Insurance", to: "/financial-services-insurance" },
                { label: "Human Life Sciences", to: "/human-life-sciences" },
                { label: "Plant & Animal Sciences", to: "/plant-&-animal-sciences" },
                { label: "Technology", to: "/technology" },
            ],
        },
    },
    {
        type: "dropdown",
        label: "Projects",
        clickableLabel: false,
        visible: true,
        leftColumn: {
            title: "Current Initiatives",
            items: [
                { label: "DataSphere", to: "/datasphere" },
                { label: "Heartland Cyber Range", to: "/heartland-cyber-range" },
                { label: "Secure Space Campus", to: "/secure-space-campus" },
                { label: "TalentSphere", to: "/talentsphere" },
            ],
        },
    },
    { type: "link", label: "Asset Map", to: "/asset-map", visible: true },
    { type: "link", label: "Resources", to: "/resources", visible: true },
];

const fallbackNavCta = { label: "Explore the Data", href: "/explore-data/kansas/", visible: true };
const fallbackContactLink = { label: "Contact Us", href: "/contact-us", visible: true };
const fallbackFooter = {
    copyrightText: "Copyright @ 2025 EnterpriseKC",
    locationHeading: "Location",
    address: "11150 Overbrook Road\nLeawood, Kansas 66211",
    addressHref: "https://www.google.com/maps/search/?api=1&query=11150+Overbrook+Road+Leawood+Kansas+66211",
    conversationHeading: "Start a conversation",
    email: "info@enterprise-kc.com",
    phone: "+1 913-728-0133",
    instagramHref: "https://www.instagram.com/enterprisekc_/",
    linkedinHref: "https://www.linkedin.com/company/enterprisekc/",
    sealImageUrl: "https://usfcr.com/assets/img/verified-vendor-seal-2024-sm.png",
    sealHref: "https://usfcr.com",
    privacyLabel: "Privacy Policy",
    privacyHref: "/privacy-policy",
};

const MainLayout = () => {
    const outlet = useOutlet();
    const [cmsNavItems, setCmsNavItems] = useState<NavItem[] | null>(null);
    const [cmsNavCta, setCmsNavCta] = useState<{ label?: string; href?: string; visible?: boolean } | undefined>();
    const [cmsContactLink, setCmsContactLink] = useState<{ label?: string; href?: string; visible?: boolean } | undefined>();
    const [footerConfig, setFooterConfig] = useState<any>(null);

    useEffect(() => {
        let mounted = true;
        getSiteGlobals()
            .then((res) => {
                if (!mounted) return;
                const globals = res?.data || {};
                if (Array.isArray(globals.nav?.items)) {
                    setCmsNavItems(globals.nav.items);
                    setCmsNavCta(globals.nav.cta);
                    setCmsContactLink(globals.nav.contactLink);
                }
                if (globals.footer) {
                    setFooterConfig(globals.footer);
                }
            })
            .catch(() => {
                if (mounted) {
                    setCmsNavItems(null);
                    setCmsContactLink(undefined);
                    setFooterConfig(null);
                }
            });
        return () => { mounted = false; };
    }, []);

    return (
        <>
            <NavBar
                logo={logo}
                navItems={cmsNavItems || fallbackNavItems}
                navCta={cmsNavCta || fallbackNavCta}
                contactLink={cmsContactLink || fallbackContactLink}
            />
            {outlet}
            <ScrollToTop />
            <Footer logo={logo} copyrightText={fallbackFooter.copyrightText || ''} config={footerConfig || fallbackFooter} />
        </>
    );
};

export default MainLayout;
